// Base
import { create } from "zustand";

// Types
import type { CartStore, CartState } from "@/types/types";

const initialState: CartState = {
  selectedProduct: null,
  warrantyState: undefined,
  isDiscountApplied: false,
  discountCode: undefined,
  paypalHandler: "standart",
  cartTotal: "0.00",
};

export const useCartStore = create<CartStore>((set) => ({
  ...initialState,
  setSelectedProduct: (payload) => set({ selectedProduct: payload }),
  setPaypalHandler: (payload) => set({ paypalHandler: payload }),
  setWarrantyState: (warrantyState) => set({ warrantyState }),
  setCartTotal: (val) =>
    set({
      cartTotal: typeof val === "number" ? val.toFixed(2) : String(val),
    }),
}));
